var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    { staticClass: "flex items-center", class: _vm.containerClasses },
    [
      _c(
        "span",
        { staticClass: "flex items-center h-12 mr-2" },
        [_c("NavigationIcon", { attrs: { shownIconComponentName: _vm.icon } })],
        1
      ),
      _c("span", { class: _vm.titleClasses }, [
        _vm._v(" " + _vm._s(_vm.title) + " "),
      ]),
      _vm.innerComponent
        ? _c(
            "span",
            { staticClass: "ml-2" },
            [
              _c(
                _vm.innerComponent.name,
                _vm._b(
                  { tag: "component", staticClass: "cursor-pointer" },
                  "component",
                  _vm.innerComponent.props,
                  false
                )
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }